import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles(theme => ({
  formControl: {
    // margin: theme.spacing(2),
    maxWidth: 230,
    minWidth: 150,
    marginInline: 15
  },
  selectEmpty: {
    // marginTop: theme.spacing(2)
  }
}));

// const StyledSelect = withStyles({
//   root: {
//     border: 0,
//     margin: 0
//   }
// })(Select);

function MaterialSelect(props) {
  const classes = useStyles();
  return (
    <FormControl className={classes.formControl}>
      <InputLabel htmlFor={props.name}>{props.dateLabel}</InputLabel>
      <Select
        labelId={props.name}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
      >
        <MenuItem></MenuItem>
        {props.data
          ? props.data.map(item => {
              return (
                <MenuItem key={item.id} value={item.id}>
                  {item.name ? item.name : item.description}
                </MenuItem>
              );
            })
          : null}
      </Select>
    </FormControl>
  );
}

export default MaterialSelect;
